import { SipTransportProtocol } from './sip-transport-protocol.enum';

export const PROTOCOL_OPTIONS: { value: SipTransportProtocol; label: string }[] = [
  { value: SipTransportProtocol.UDP, label: 'UDP' },
  { value: SipTransportProtocol.TCP, label: 'TCP' },
  { value: SipTransportProtocol.TLS, label: 'TLS' },
];
